/** Display Learning as Concept / Why / Outcome / two links only. */
export function sanitizeLearningContent(content) {
  const raw = String(content || "").replace(/\\n/g, "\n");
  const lines = raw
    .split(/\n/)
    .map((l) => l.trim())
    .filter(Boolean);

  let concept = "";
  let why = "";
  let outcome = "";
  const links = [];

  for (const line of lines) {
    const text = line.replace(/^▶\s*/, "").replace(/^[·•]\s*/, "").trim();
    if (/^concept\s*:/i.test(text)) {
      concept = text
        .replace(/^concept\s*:\s*/i, "")
        .replace(/\s*\(also[^)]*\)/i, "")
        .replace(/\s*[—–-]\s*same idea.*$/i, "")
        .trim();
      continue;
    }
    if (/^(why|purpose)\s*:/i.test(text)) {
      why = text.replace(/^(why|purpose)\s*:\s*/i, "").trim();
      continue;
    }
    if (/^outcome\s*:/i.test(text)) {
      outcome = text.replace(/^outcome\s*:\s*/i, "").trim();
      continue;
    }
    if (
      /^(links?|helpful links|subject today|heading|topics today|transition|done when|practice \d)/i.test(
        text
      ) ||
      /how it links|build hook|from your upload|ctrl\+f|shared topic|your learn focus|motivation:/i.test(
        line
      )
    ) {
      continue;
    }
    if (/https?:\/\//i.test(line) || /website\s*:|youtube\s*:|video\s*:/i.test(line)) {
      const cleaned = `   · ${text.replace(/^website\s*\/\s*article\s*:/i, "Website:")}`;
      if (!links.includes(cleaned)) links.push(cleaned);
    }
  }

  const structured = Boolean(concept || why || outcome);
  if (!concept) {
    const heading = lines.find((l) =>
      /heading:|learn today:|learn day|new learning:|one topic today:/i.test(l)
    );
    if (heading) {
      concept = heading
        .replace(/^▶\s*/, "")
        .replace(/^(heading|learn today|learn day\s*\d+|new learning|one topic today)\s*:\s*/i, "")
        .replace(/^deepen\s*[—–-]\s*/i, "")
        .trim();
    }
  }
  if (!structured && !concept) {
    return raw.trim();
  }

  const out = [
    `▶ Concept: ${concept || "today's concept"}`,
    why ? `▶ Why: ${why}` : null,
    outcome ? `▶ Outcome: ${outcome}` : null,
  ].filter(Boolean);
  if (!why && !outcome && raw.trim() && !/^▶ Concept:/i.test(raw)) {
    const rest = lines.filter((l) => !/^(concept|why|purpose|outcome)\s*:/i.test(l.replace(/^▶\s*/, "")));
    if (rest.length) out.push(rest.join("\n"));
  }
  const few = links.slice(0, 2);
  if (few.length) {
    out.push("▶ Links:");
    out.push(...few);
  }
  return out.join("\n");
}

export function displayRowContent(activity, content) {
  return removeFeedsNext(content).replace(/(^|\n)\s*(?:▶\s*)?Done when\s*:/gi, "$1▶ Deliverable:");
}

/** Remove the redundant learning-to-next-step hint added by older plan generators. */
export function removeFeedsNext(content) {
  return String(content || "")
    .replace(/\\n/g, "\n")
    .split("\n")
    .filter((line) => !/^\s*(?:▶\s*)?Feeds next\s*:/i.test(line))
    .join("\n")
    .replace(/\n{3,}/g, "\n\n")
    .trim();
}
